/**
 *
 * DocumentSplitter/utils
 *
 */

import cloneDeep from 'lodash/cloneDeep';
import { Invoice } from 'lib/api/invoice';
import { InvoiceForSplittingWithSrc } from 'lib/api/invoiceContainer';

const INVOICE_ITEM_SIZE = 256; // width
const INVOICE_BUTTON_SIZE = 65; // width
const INVOICE_PAGE_ITEM_SIZE = 313; // height
const INVOICE_PAGE_BUTTON_SIZE = 58; // height

export function deriveInvoicesForSplitting(invoices: Invoice[]): InvoiceForSplittingWithSrc[] {
  return invoices.map((invoice) => ({
    InvoiceId: invoice.InvoiceId,
    Pages: invoice.Pages.map((page) => ({ Src: page.Src, PageNo: page.PageNo, Deleted: false })),
  }));
}

export function togglePageDeleted(
  invoices: InvoiceForSplittingWithSrc[],
  invoiceIndex: number,
  pageIndex: number,
) {
  const nextInvoices = cloneDeep(invoices);
  const deleted = nextInvoices[invoiceIndex].Pages[pageIndex].Deleted;
  nextInvoices[invoiceIndex].Pages[pageIndex].Deleted = !deleted;
  return nextInvoices;
}

export function splitAfter(
  invoices: InvoiceForSplittingWithSrc[],
  invoiceIndex: number,
  pageIndex: number,
) {
  const nextInvoices = cloneDeep(invoices);
  nextInvoices.splice(invoiceIndex + 1, 0, {
    InvoiceId: nextInvoices[invoiceIndex].InvoiceId,
    Pages: nextInvoices[invoiceIndex].Pages.splice(pageIndex + 1),
  });
  return nextInvoices;
}

export function joinAfter(invoices: InvoiceForSplittingWithSrc[], invoiceIndex: number) {
  const nextInvoices = cloneDeep(invoices);
  nextInvoices[invoiceIndex].Pages = nextInvoices[invoiceIndex].Pages.concat(
    nextInvoices.splice(invoiceIndex + 1, 1)[0].Pages,
  );
  return nextInvoices;
}

const getSize = (direction: 'vertical' | 'horizontal' = 'vertical') => {
  // On vertical list size represents height and on horizontal list it represents width.
  const itemSize = direction === 'vertical' ? INVOICE_PAGE_ITEM_SIZE : INVOICE_ITEM_SIZE;
  const buttonSize = direction === 'vertical' ? INVOICE_PAGE_BUTTON_SIZE : INVOICE_BUTTON_SIZE;
  return { itemSize, buttonSize };
};

export const getItemSize = (
  direction: 'vertical' | 'horizontal' = 'vertical',
  index: number,
  zoom: number,
) => {
  const { itemSize, buttonSize } = getSize(direction);
  return index % 2 ? buttonSize : itemSize * zoom;
};

export const getEstimatedItemSize = (
  direction: 'vertical' | 'horizontal' = 'vertical',
  zoom: number,
) => {
  const { itemSize, buttonSize } = getSize(direction);
  return (itemSize * zoom + buttonSize) / 2;
};
